export default "__VITE_ASSET__5QWGg5Gj__"